import React from "react";
import {
  Create,
  SimpleForm,
  ReferenceInput,
  TextInput,
  BooleanInput,
  required,
  email,
  AutocompleteInput
} from "admin-on-rest";
import AutoComplete from "material-ui/AutoComplete";
import {validateCustomerData, validatePhone} from "./validations";

class CustomerCreateForm extends React.Component {
  render() {
    const props = {...this.props};
    return (
      <Create {...props}>
        <SimpleForm redirect="list" validate={validateCustomerData}>
          <ReferenceInput
            label="resources.customers.inputs.storeName"
            source="kiosk_id"
            reference="kiosks"
            validate={required}
            sort={{field: "name", order: "ASC"}}
            allowEmpty
          >
            <AutocompleteInput
              source="name"
              optionText="name"
              options={{filter: AutoComplete.caseInsensitiveFilter}}
            />
          </ReferenceInput>

          <TextInput
            label="resources.customers.inputs.firstName"
            source="first_name"
          />
          <TextInput
            label="resources.customers.inputs.lastName"
            source="last_name"
          />
          <TextInput
            label="resources.customers.inputs.email"
            source="email"
            type="email"
            validate={email}
          />
          <TextInput
            label="resources.customers.inputs.phoneNumber"
            source="phone"
            validate={validatePhone}
          />
          <BooleanInput
            label="resources.customers.inputs.active"
            source="active"
            defaultValue
          />
        </SimpleForm>
      </Create>
    );
  }
}

export default CustomerCreateForm;



// WEBPACK FOOTER //
// ./src/containers/CRM/Customers/CustomerCreateForm.js